import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vSelect from "vue-select"

import MetaInfo from 'vue-meta-info';

Vue.use(MetaInfo)

import "vue-select/dist/vue-select.css"

Vue.component("v-select", vSelect)

// 运行环境
const nodeEnv = process.env.NODE_ENV
Vue.prototype.$nodeEnv = nodeEnv

// normalize css
import './assets/style/normalize.css'
import './assets/style/common.less'

Vue.config.productionTip = false

Vue.filter('pageTitle', (val) => {
    const lang = localStorage.getItem('lang') || 'cn'

    if (lang === 'cn') {
        return val ? '　' + val: ''
    }

    return val
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
